import { render, staticRenderFns } from "./DashboardHome.vue?vue&type=template&id=3e0134aa"
import script from "./DashboardHome.vue?vue&type=script&lang=js"
export * from "./DashboardHome.vue?vue&type=script&lang=js"
import style0 from "./DashboardHome.vue?vue&type=style&index=0&id=3e0134aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports